// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

const getHasAccessoriesProperty = (obj?: { properties?: Dictionary<string> }) => {
    return getBooleanProperty(obj?.properties?.productHasAccessories ?? obj?.properties?.hasAccessories);
};

export default getHasAccessoriesProperty;
